import { render, staticRenderFns } from "./account_settings.vue?vue&type=template&id=1cc51595&scoped=true"
import script from "./account_settings.vue?vue&type=script&lang=js"
export * from "./account_settings.vue?vue&type=script&lang=js"
import style0 from "./account_settings.vue?vue&type=style&index=0&id=1cc51595&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc51595",
  null
  
)

export default component.exports